import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Selectormes } from './selectormes.component';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
	declarations: [
		Selectormes
	],
	imports: [
		CommonModule,
		MatButtonToggleModule,
		MatButtonModule
	],
	exports: [
		Selectormes
	]
})
export class SelectormesModule { }
